import { UserContext } from "../utils/UserContext";
import { getProperties } from "aws-amplify/storage";

export class DocumentVersionManager {
  constructor(private client: any) {}

  private async getS3Metadata(s3Key: string): Promise<{
    eTag: string;
  }> {
    try {
      const properties = await getProperties({
        path: s3Key,
      });

      const cleanETag = (properties.eTag || "").replace(/^"|"$/g, "");

      return {
        eTag: cleanETag,
      };
    } catch (error) {
      console.error("Error getting S3 metadata:", error);
      return {
        eTag: "",
      };
    }
  }

  async createNewVersion(
    existingDocId: string,
    newDocumentData: any,
    userContext: UserContext,
  ): Promise<string> {
    const newVersion = `${Date.now()}`;

    const s3Metadata = await this.getS3Metadata(newDocumentData.fileKey);

    await this.client.models.Document.update(
      {
        userId: userContext.identityId,
        documentId: existingDocId,
        isLatestVersion: false,
        status: "INACTIVE",
      },
      { authMode: "userPool", authToken: userContext.token },
    );

    const { data: newDoc } = await this.client.models.Document.create(
      {
        ...newDocumentData,
        version: newVersion,
        s3ETag: s3Metadata.eTag,
        contentHash: newDocumentData.contentHash,
        previousVersionId: existingDocId,
        isLatestVersion: true,
        status: "ACTIVE",
      },
      { authMode: "userPool", authToken: userContext.token },
    );

    return newDoc!.documentId;
  }

  async createInitialVersion(
    documentData: any,
    userContext: UserContext,
  ): Promise<string> {
    const s3Metadata = await this.getS3Metadata(documentData.fileKey);

    const { data: newDoc } = await this.client.models.Document.create(
      {
        ...documentData,
        userId: userContext.identityId,
        version: "1",
        s3ETag: s3Metadata.eTag,
        contentHash: documentData.contentHash,
        previousVersionId: null,
        isLatestVersion: true,
        status: "ACTIVE",
      },
      { authMode: "userPool", authToken: userContext.token },
    );

    return newDoc!.documentId;
  }
}
